// Global defaults one may want to configure
const hasDOM = typeof document !== "undefined";

export default {
	gamut_mapping: "lch.c",
	precision: 5,
	deltaE: "76", // Default deltaE method
};
